<div class="page-padding" style="padding: 24px;">
  <div style="margin-left: 39%;" *ngIf="equipmentDetails == null" [@enterAnimation]>
    <mat-spinner></mat-spinner>
  </div>


  <div #btnStatusChange class="alert cursor-pointer" (click)="openChangeStatusModal()" *ngIf="showImplement"
    (mouseenter)="mouseOverStatus()" (mouseleave)="mouseLeaveStatus()">
    <i class="material-icons alert__icon">build</i>
    <div class="alert__content">
      <span class="alert__content__title">{{implementStatusText}}</span>
      <span class="alert__content__message" [innerHTML]="implementStatusDesc"></span>
    </div>
  </div>


  <div class="panel" *ngIf="equipmentDetails != null &&  !showImplementStatusModal">
    <mat-expansion-panel class="parametersPanel">
      <mat-expansion-panel-header>
        <div class="panel__header">
          <span class="panel__header__title" style="    margin-left: -24px;">
            Equipment Details
          </span>
        </div>
      </mat-expansion-panel-header>
      <div class="panel__content flex flex--align-center">
        <div class="overall-eval-container">
          <img [src]="getImage(equipmentDetails.EquipmentPhoto)" class="equipment-photo" />
          <div class="bold font-size--xl margin-r--24 {{getEvalClass(equipmentDetails.PercentWorn)}}"
            style="border-radius: 4px;color: white;     padding-top: 12%;">
            {{equipmentDetails.PercentWorn | number:'1.0-1'}}%
          </div>
        </div>
        <div class="column-container flex-grow">
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Customer
              </span>
              <span class="text-block__important">
                {{equipmentDetails.CustomerName}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Job Site
              </span>
              <span class="text-block__important">
                {{equipmentDetails.JobsiteName}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Serial Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.SerialNumber}}
                </a>
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Unit Number
              </span>
              <span class="text-block__important">
                <a routerLink="/get-equipment/{{equipmentDetails.equipmentId}}">
                  {{equipmentDetails.UnitNumber}}
                </a>
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Last Inspection Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.LastInspectionDate}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Next Inspection Date
              </span>
              <span class="text-block__important">
                {{ equipmentDetails.NextInspectionDate }}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Meter Reading (SMU)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Smu}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Life to Date (LTD)
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Ltd}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Make
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Make}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Model
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Model}}
              </span>
            </div>
          </div>
          <div class="column-container__column">
            <div class="text-block">
              <span class="text-block__label">
                Family
              </span>
              <span class="text-block__important">
                {{equipmentDetails.Family}}
              </span>
            </div>
            <div class="text-block">
              <span class="text-block__label">
                Setup Date
              </span>
              <span class="text-block__important">
                {{equipmentDetails.EquipmentSetupDate}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="panel" *ngIf="equipmentDetails != null &&  showImplementStatusModal">
    <div class="panel__header">
      <span class="panel__header__title">
        Inventory Details
      </span>
      <!-- <button *ngIf="implement.status =='Undergoing Rebuild'" mat-raised-button color="warn" (click)="CompleteRebuild()">Complete Rebuild</button> -->
    </div>
    <div class="panel__content flex flex--align-center">

      <div class="column-container flex-grow" style="justify-content: space-evenly;">
        <div class="column-container__column">
          <div class="input-container">

            <mat-form-field style="width:220px">
              <mat-label>Inventory Status: </mat-label>
              <mat-select [(ngModel)]="equipmentDetails.InventoryStatus" (selectionChange)="UpdateInventoryStatus()">
                <mat-option value="" disabled selected>Select Status</mat-option>
                <mat-option *ngFor="let status of statusList" [value]="status.Id">{{status.Name}}</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- <span class="label">Inventory Status</span>
            <select (change)="statusSelected($event.target.value)" class="get-Input" [(ngModel)]="equipmentDetails.InventoryStatus">
                <option value="" disabled selected>Select Status</option>
                <option *ngFor="let status of statusList" [value]="status.Id">{{status.Name}}</option>
            </select> -->
          </div>

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{equipmentDetails.CustomerName}}
            </span>
          </div>

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{equipmentDetails.JobsiteName}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex columns" *ngIf="equipmentDetails != null">
    <div class="panel panel--tasks" style="flex-shrink: 0.1;width:70%;height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Tasks
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="height: 165px;">
        <!-- <a class="square-button" (click)="openImplementAction()" *ngIf="!isJobRoleDefault && EnablePreference.showImplementAction">
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Asset Repairs</span>
        </a> -->
        <a class="square-button" (click)="openImplementAction()"
          *ngIf="!isJobRoleDefault && EnablePreference.showImplementAction">
          <i *ngIf="equipmentDetails.IsPendingAssetActions" class="material-icons asset-flag" title="Asset Action Pending">
            flag
          </i>
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Asset Repairs</span>
        </a>
        <a class="square-button" *ngIf="isJobRoleDefault && EnablePreference.showImplementAction"
          style="color: lightgrey;">
          <!-- <i *ngIf="equipmentDetails.IsPendingAssetActions" class="material-icons asset-flag" title="Asset Action Pending">
            flag
          </i> -->
          <i class="material-icons square-button__icon">mode_edit</i>
          <span class="square-button__label">Asset Repairs</span>
        </a>
        <a class="square-button" *ngIf="EnablePreference.showDocLib" (click)="openDocumentLibrary()">
          <i class="material-icons square-button__icon">account_balance</i>
          <span class="square-button__label">Document Library</span>
        </a>

        <a matTooltip="Only Available in Inventory"
          *ngIf="!showImplementStatusModal || isJobRoleDefault && EnablePreference.showRebuildImplement"
          class="square-button" style="color: lightgray">
          <i class="material-icons square-button__icon">restore_page</i>
          <span class="square-button__label">Asset Rebuild </span>
        </a>
        <a *ngIf="showImplementStatusModal && !isJobRoleDefault && EnablePreference.showRebuildImplement"
          class="square-button" (click)="openRebuildImplement()">
          <i class="material-icons square-button__icon">restore_page</i>
          <span class="square-button__label">Asset Rebuild </span>
        </a>
        <a *ngIf="!showImplementStatusModal && !isJobRoleDefault && EnablePreference.showChangeJobsite"
          class="square-button" (click)="openChangeJobsite()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showChangeJobsite"
          class="square-button" (click)="openChangeJobsiteInventory()">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="!showImplementStatusModal && isJobRoleDefault && EnablePreference.showChangeJobsite"
          class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>

        <a *ngIf="showImplementStatusModal  && isJobRoleDefault && EnablePreference.showChangeJobsite"
          class="square-button" style="color: lightgrey;">
          <i class="material-icons square-button__icon">language</i>
          <span class="square-button__label">Change Jobsite</span>
        </a>


        <a *ngIf="!showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showUpdateUsage"
          class="square-button" (click)="openUpdateMeter()">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Usage</span>
        </a>
        <a *ngIf="showImplementStatusModal  && isJobRoleDefault && EnablePreference.showUpdateUsage"
          class="square-button" style="color: lightgray">
          <i class="material-icons square-button__icon">access_time</i>
          <span class="square-button__label">Update Usage</span>
        </a>

        <!-- old code- *ngIf= "!showImplementStatusModal" -->
        <a *ngIf="!showImplementStatusModal && !isJobRoleDefault && EnablePreference.showMoveImplement"
          class="square-button" target="_blank" (click)="openRemoveImplementModal()" style="width: max-content">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move Asset</span>
        </a>

        <a *ngIf="!showImplementStatusModal && isJobRoleDefault && EnablePreference.showMoveImplement"
          class="square-button" target="_blank" style="width: max-content;color: lightgray">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move Asset</span>
        </a>

        <a *ngIf="showImplementStatusModal && implement.status !='Undergoing Rebuild' && !isJobRoleDefault && EnablePreference.showMoveImplement"
          class="square-button" target="_blank" (click)="openAttachImplementModal()" style="width: max-content">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move Asset</span>
        </a>

        <!-- old code-  *ngIf="showImplementStatusModal && implement.status =='Undergoing Rebuild' || isJobRoleDefault" -->
        <a *ngIf="showImplementStatusModal && implement.status =='Undergoing Rebuild' && isJobRoleDefault && EnablePreference.showMoveImplement"
          class="square-button" target="_blank" style=" width: max-content; color: lightgray">
          <i class="material-icons square-button__icon">swap_vertical_circle</i>
          <span class="square-button__label">Move Asset</span>
        </a>

        <!-- product Improvement -->
        <a class="square-button" *ngIf="EnablePreference.showPIP" (click)="openProductImprovement()">
          <i class="material-icons square-button__icon">fact_check</i>
          <span class="square-button__label">Product Improvement Program</span>
        </a>

        <a *ngIf="showImplementStatusModal && implement.status !='Undergoing Rebuild' && !isJobRoleDefault && EnablePreference.showImplementTarget"
          class="square-button" (click)="openUpdateTargets()">
          <i class="material-icons square-button__icon">gps_fixed</i>
          <span class="square-button__label">Implements Targets</span>
        </a>

        <a matTooltip="Only Available in Inventory"
          *ngIf="!showImplementStatusModal || implement.status =='Undergoing Rebuild' || isJobRoleDefault && EnablePreference.showImplementTarget"
          class="square-button" style="color: lightgray">
          <i class="material-icons square-button__icon">gps_fixed</i>
          <span class="square-button__label">Implements Targets</span>
        </a>

        <a *ngIf="!showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showPerformInsp"
          class="square-button" target="_blank" href="/get-inspection/{{equipmentDetails.equipmentId}}/{{ImplementId}}">
          <i class="material-icons square-button__icon">find_in_page</i>
          <span class="square-button__label">Perform Inspection</span>
        </a>
        <a *ngIf="showImplementStatusModal  && !isJobRoleDefault && EnablePreference.showPerformInsp"
          class="square-button" target="_blank" href="/get-inspection/{{equipmentDetails.equipmentId}}/{{ImplementId}}">
          <i class="material-icons square-button__icon">find_in_page</i>
          <span class="square-button__label">Perform Inspection</span>
        </a>

        <a *ngIf="!showImplementStatusModal  && isJobRoleDefault && EnablePreference.showPerformInsp"
          style="color: lightgray" class="square-button">
          <i class="material-icons square-button__icon">find_in_page</i>
          <span class="square-button__label">Perform Inspection</span>
        </a>
        <a *ngIf="showImplementStatusModal && isJobRoleDefault && EnablePreference.showPerformInsp"
          style="color: lightgray" class="square-button">
          <i class="material-icons square-button__icon">find_in_page</i>
          <span class="square-button__label">Perform Inspection</span>
        </a>

        <a class="square-button" (click)="OpenExisitingImp()"
          *ngIf="!isJobRoleDefault && EnablePreference.showModifyAst">
          <i class="material-icons square-button__icon">edit_note</i>
          <span class="square-button__label">Modify Asset</span>
        </a>


        <a class="square-button" *ngIf="isGray && EnablePreference.showWarrantySts"
          style="cursor: pointer;color: #8b8383;">
          <i class="material-icons square-button__icon" (click)="openWarrantyStatus()">shield</i>
          <span class="square-button__label">Warranty Status</span>
        </a>

        <a class="square-button" *ngIf="isGreen && EnablePreference.showWarrantySts"
          style="color: green;cursor: pointer;">
          <i class="material-icons square-button__icon" (click)="openWarrantyStatus()">verified_user</i>
          <span class="square-button__label">Warranty Status</span>
        </a>
        <a class="square-button" *ngIf="isOrange && EnablePreference.showWarrantySts"
          style="color: orange;cursor: pointer;">
          <i class="material-icons square-button__icon" (click)="openWarrantyStatus()">verified_user</i>
          <span class="square-button__label">Warranty Status</span>
        </a>
        <a class="square-button" *ngIf="isRed && EnablePreference.showWarrantySts" style="color: red;cursor: pointer;">
          <i *ngIf="isRed && !isExpired" class="material-icons square-button__icon"
            (click)="openWarrantyStatus()">verified_user</i>
          <i *ngIf="isRed && isExpired" class="material-icons square-button__icon"
            (click)="openWarrantyStatus()">gpp_bad</i>
          <span class="square-button__label">Warranty Status</span>
        </a>

        <a class="square-button" (click)="OpenCopyAdvanced()"
          *ngIf="!isJobRoleDefault && EnablePreference.showCopyFrmTemp">
          <i class="material-icons square-button__icon">content_copy</i>
          <span class="square-button__label">Copy from Template</span>
        </a>
        <a class="square-button" title="Toggle Single Point Crack Entry Mode">
          <mat-checkbox [(ngModel)]="implement.SinglePointCrackEntry" (change)="singlePointCrackEntryHandler()"
            class="single-point-crack-entry new-single-point-checkbox"></mat-checkbox>
          <span class="square-button__label" style="white-space: nowrap;">Single Point</span>
          <span class="square-button__label">Crack Entry</span>
        </a>
        <!-- <a class="square-button" target="_blank" (click)="openImplementSortOrder()">
    <i class="material-icons square-button__icon">swap_vert</i>
    <span class="square-button__label">Implement Sort Order</span>
  </a> -->
      </div>
    </div>


    <div class="panel panel--next-inspection" style="flex-shrink:0.1; margin-left: 0; height: 210px; width: 11%;">
      <div class="panel__header">
        <span class="panel__header__title">
          Next Inspection
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch">
        <div class="square-button" (click)="openInspectionPlannerDialog()">
          <i class="material-icons square-button__icon">event_note</i>
          <span class="smuReadings">Smu : {{equipmentDetails.NextSmu}}</span>
          <span class="square-button__label">{{ equipmentDetails.NextInspectionDate| date:'dd/MMM/yyyy' }}</span>
        </div>
      </div>
    </div>

    <div class="panel panel--inspections" style="margin-left:10px;width: 512px; height: 210px;">
      <div class="panel__header">
        <span class="panel__header__title">
          Inspection History
        </span>
      </div>
      <div class="panel__content flex flex--align-stretch" style="overflow-x: auto;     justify-content: start;">

        <div class="square-button" *ngFor="let inspection of inspectionDetails;" [matMenuTriggerFor]="inspectionMenu">
          <!-- <ng-container *ngFor="let item of inspection.InspectionsDetails | slice:0:3; let i=index"  > -->
          <div class=" CelltextWrap {{getEvalCode(inspection.Eval)}}" style="width: 90px;text-align: center;">
            <span class="square-button__label CelltextWrap  " style="color: white; padding: 1px;"
              title="{{inspection.ImplementName}} / SMU - {{inspection.SMU}}">{{inspection.ImplementName}}</span>
          </div>
          <!-- </ng-container> -->
          <!-- <div *ngIf="inspection.InspectionsDetails.length>=4">
            <span class="smuReadings">... and {{inspection.InspectionsDetails.length -3}} more</span>
          </div> -->
          <!-- <i class="square-button__icon {{getEvalCode(inspection.Eval)}}">{{inspection.Eval}}</i> -->
          <span class="smuReadings">Smu : {{inspection.SMU}}</span>
          <span class="square-button__label"
            style="margin-top: 10px; white-space: nowrap; ">{{inspection.InspectionDate}}</span>
          <a *ngIf="inspection.isDocAttached==true">
            <i class="material-icons">description</i>
            <span class="square-button__label">{{inspection.DocCount}}</span>
          </a>
          <mat-menu #inspectionMenu="matMenu">
            <button *ngIf="!isJobRoleDefault" mat-menu-item
              (click)="openLink('impinspection', inspection.InspectionDate, inspection)">{{'View / Edit'}}</button>

            <!-- <button mat-menu-item (click)="openLink('pdf', inspection.InspectionDate, inspection)">{{inspection.GETType + ' PDF Report'}}</button> -->
            <button mat-menu-item
              (click)="GenerateTelerikPDF(inspection.InspectionDate, inspection)">{{inspection.GETType + ' PDF
              Report'}}</button>
            <button mat-menu-item (click)="HideInspection(inspection)">{{'Hide Inspection'}}</button>
            <button *ngIf="inspection.isDocAttached==true" mat-menu-item
              (click)="openAttachedDocs(inspection.SMU,inspection.InspectionDate, inspection.ImplementInspectionId)">{{'View
              Documents'}}</button>
            <button *ngIf="inspection.isDocAttached==false" mat-menu-item
              (click)="openAttachedDocs(inspection.SMU,inspection.InspectionDate, inspection.ImplementInspectionId)">{{'Add
              Doc.'}}</button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
  <div style="margin-left: 39%; position:absolute; z-index:99;" *ngIf="loading">
    <mat-spinner> </mat-spinner>
  </div>
  <mat-tab-group [(selectedIndex)]="selectedTab" (selectedTabChange)="tabChanged($event)">

    <div *ngIf="equipmentDetails != null">

      <mat-tab label="ASSET DETAILS">
        <div *ngIf="SchematicAndObservationPoints != null">
          <div class="filteroptionsflex">
            <div>
              <i *ngIf="!showBar" class="material-icons" (click)="ShowHidefield()"
                style="cursor: pointer; transform: scale(1) rotate(90deg); color: #428bca;" title="Show filter options">
                forward
              </i>
              <i *ngIf="showBar" class="material-icons" (click)="ShowHidefield()"
                style="cursor: pointer; transform: scale(1) rotate(270deg); color: #428bca;"
                title="Hide filter options">
                forward
              </i>
            </div>
            <div *ngIf="showBar">
              <div style="padding: 5px 0 10px 0;">
                <span class="displaycolumnheadersfor">{{ "Display Components" | translate | async }} </span>
              </div>
              <div>
                <div class="filteroptionsflexrow">
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="displayCritical" (click)="loadAssetDetails()"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Critical" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="displayNonCritical" (click)="loadAssetDetails()"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Non Critical" | translate |async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="displayGET" (click)="loadAssetDetails()"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"GET" | translate |async}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="showBar" style="padding-left: 70px;">
              <div style="padding: 5px 0 10px 0;">
                <span class="displaycolumnheadersfor">{{ "Display Cracks" | translate | async }} </span>
              </div>
              <div>
                <div class="filteroptionsflexrow">
                  <div class="filteroptionsflexcolumn" *ngFor="let option of crackOptions">
                    <mat-checkbox [(ngModel)]="option.isSelected" (change)="showCrack()"></mat-checkbox>
                    <div class="filteroptionslabel">
                      <span>{{ option.CrackStatus }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="showBar" style="padding-left: 70px;">
              <div style="padding: 5px 0 10px 0;">
                <span class="displaycolumnheadersfor">{{ "Display Columns" | translate | async }} </span>
              </div>
              <div>
                <div class="filteroptionsflexrow">
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showOPType"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"OP Type" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showImagesHistory"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"History" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showWorn"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>% {{"Worn" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showCrackLength"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Crack Length" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showCurrentMeasure"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Current Measure" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showLocationName"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Location" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn" *ngIf="crackSeverityList">
                    <div>
                      <mat-checkbox [(ngModel)]="showCrackSeverity"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Obs. Severity" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showStartingDim"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Starting Dim" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showUsedLimit"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Used Limit" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showBudgetLife"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Budget Life" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showLife"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Life (hrs)" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showResidualLife100"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Residual Life (hrs) 100%" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showResidualLife120"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Residual Life (hrs) 120%" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showLifeTotalProjected"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Life Total Projected" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showInstallDate"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Install Date" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showPartNo"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Part No." | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showManufacturer"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"Manufacturer" | translate | async}}</span>
                    </div>
                  </div>
                  <div class="filteroptionsflexcolumn">
                    <div>
                      <mat-checkbox [(ngModel)]="showAllCosts"></mat-checkbox>
                    </div>
                    <div class="filteroptionslabel">
                      <span>{{"All Costs" | translate | async}}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!--<ng-container *ngFor="let implement of ImplementForEquipmentDetails">-->
          <div>
            <div style="background-color: white; padding: 5px; max-width: 100%;"
              *ngIf="ImplementSummaryForEquipmentDetails != null">
              <app-implement-details-header
                [Implemetdetails]="ImplementSummaryForEquipmentDetails"></app-implement-details-header>
            </div>
            <ng-container *ngFor="let schematic of SchematicAndObservationPoints">
              <app-implement-asset-details [SchematicId]="schematic.Schematic.Id" [(cusID)]="CustomerId"
                [ImplementId]="ImplementId" [(SMU)]="SMU" [isCrack]="1" [(equipmentId)]="equipmentId"
                [displayCritical]="displayCritical" [displayNonCritical]="displayNonCritical" [displayGET]="displayGET"
                [showOPType]="showOPType" [showImageHx]="showImageHx" [showWorn]="showWorn" [showCrackLength]="showCrackLength"
                [showCurrentMeasure]="showCurrentMeasure" [showCrackSeverity]="showCrackSeverity"
                [showStartingDim]="showStartingDim" [showUsedLimit]="showUsedLimit" [showBudgetLife]="showBudgetLife"
                [showLife]="showLife" [showResidualLife100]="showResidualLife100"
                [showResidualLife120]="showResidualLife120" [showLifeTotalProjected]="showLifeTotalProjected"
                [showInstallDate]="showInstallDate" [showPartNo]="showPartNo" [showManufacturer]="showManufacturer"
                [showAllCosts]="showAllCosts" [crackSeverityList]="crackSeverityList"
                [activeCrackStatusIds]="activeCrackStatusIds" [showLocationName]="showLocationName"
                (updateObs)="loadAssetDetails()">
              </app-implement-asset-details>
            </ng-container>
            <!--<ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
              <app-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(SMU)]="SMU" [isCrack]="1" [(ImplementId)]="implementId" (updateObs)="loadImplementDetails()">
              </app-observation-details>
            </ng-container>-->
          </div>
          <!--</ng-container>-->
        </div>
      </mat-tab>
      <mat-tab label="ASSET ACTION HISTORY">
        <div *ngIf="historyDetails_ != null">
          <!-- <app-implement-history [(historyDetails)]="item.Implements"></app-implement-history> -->
          <div class="panel__content no-padding">

            <div>
              <table class="table table--striped table--full-width">

                <thead>
                  <tr>

                    <th class="ColumnCell">Cycle No</th>
                    <th class="ColumnCell">Total CMU</th>
                    <th class="ColumnCell">Total BCM's</th>
                    <th class="ColumnCell">Total Tons</th>
                    <th class="ColumnCell">Total Capital</th>
                    <th class="ColumnCell">Total Maintenance</th>
                    <th class="ColumnCell">Total GET Cost</th>
                    <th class="ColumnCell">Total Cost</th>

                    <th class="ColumnCell">Cost/CMU</th>
                    <th class="ColumnCell">GET Cost/CMU</th>

                    <th class="ColumnCell">Cost/BCM</th>
                    <th class="ColumnCell">GET Cost/BCM</th>

                    <th class="ColumnCell">Cost/Ton</th>
                    <th class="ColumnCell">GET Cost/Ton</th>

                  </tr>
                </thead>
                <tbody style="font-size: smaller;">
                  <ng-container *ngFor="let cycle of NewCycleList">
                    <tr>
                      <td class="ColumnCell">{{cycle.CycleNo}}</td>
                      <td class="ColumnCell">{{cycle.TotalSMU | number: '1.' }}</td>
                      <td class="ColumnCell">{{cycle.TotalBCM | number: '1.'}}</td>
                      <td class="ColumnCell">{{cycle.TotalTon | number: '1.'}}</td>
                      <td class="ColumnCell">${{cycle.TotalCapitalCost | number: '1.'}}</td>
                      <td class="ColumnCell">${{cycle.TotalMaintenanceCost | number: '1.'}}</td>
                      <td class="ColumnCell">${{cycle.TotalGETCost | number: '1.'}}</td>

                      <td class="ColumnCell">${{cycle.TotalCost | number: '1.'}}</td>

                      <td class="ColumnCell">${{(ToDecimalPoints(cycle.TotalCost,cycle.TotalSMU) == NaN)?0:
                        ToDecimalPoints(cycle.TotalCost,cycle.TotalSMU) }}</td>
                      <td class="ColumnCell">${{(ToDecimalPoints(cycle.TotalGETCost,cycle.TotalSMU) == NaN)?0:
                        ToDecimalPoints(cycle.TotalGETCost,cycle.TotalSMU) }}</td>

                      <td class="ColumnCell">${{ToDecimalPoints(cycle.TotalCost,cycle.TotalBCM) }}</td>
                      <td class="ColumnCell">${{ToDecimalPoints(cycle.TotalGETCost,cycle.TotalBCM) }}</td>

                      <td class="ColumnCell">${{ToDecimalPoints(cycle.TotalCost,cycle.TotalTon) }}</td>
                      <td class="ColumnCell">${{ToDecimalPoints(cycle.TotalGETCost,cycle.TotalTon) }}</td>


                  </ng-container>
                </tbody>
              </table>
            </div>
            <div>
              <table class="table table--striped table--full-width">

                <thead>
                  <tr>

                    <th class="ColumnCell">No Of Cycles </th>
                    <th class="ColumnCell">Total CMU</th>
                    <th class="ColumnCell">Total BCM's</th>
                    <th class="ColumnCell">Total Tons</th>
                    <th class="ColumnCell">Total Capital</th>
                    <th class="ColumnCell">Total Maintenance</th>

                    <th class="ColumnCell">Total GET Cost</th>

                    <th class="ColumnCell">Total Cost</th>
                    <th class="ColumnCell">Cost/CMU</th>
                    <th class="ColumnCell">GET Cost/CMU</th>

                    <th class="ColumnCell">Cost/BCM</th>
                    <th class="ColumnCell">GET Cost/BCM</th>

                    <th class="ColumnCell">Cost/Ton</th>
                    <th class="ColumnCell">GET Cost/Ton</th>

                  </tr>
                </thead>
                <tbody style="font-size: smaller;">
                  <ng-container>
                    <tr>
                      <td class="ColumnCell">{{totalcycle}}</td>
                      <td class="ColumnCell">{{totalsmu | number: '1.'}}</td>
                      <td class="ColumnCell">{{totalbcm | number: '1.'}}</td>
                      <td class="ColumnCell">{{totaltons | number: '1.'}}</td>
                      <td class="ColumnCell">${{totalCapitalcost | number: '1.'}}</td>
                      <td class="ColumnCell">${{totalMaintenancecost | number: '1.'}}</td>
                      <td class="ColumnCell">${{totalGETcost | number: '1.'}}</td>
                      <td class="ColumnCell">${{totalcost | number: '1.'}}</td>

                      <td class="ColumnCell">${{ToDecimalPoints(totalcost,totalsmu)}}</td>
                      <td class="ColumnCell">${{ToDecimalPoints(totalGETcost,totalsmu)}}</td>

                      <td class="ColumnCell">${{ToDecimalPoints(totalcost,totalbcm)}}</td>
                      <td class="ColumnCell">${{ToDecimalPoints(totalGETcost,totalbcm)}}</td>

                      <td class="ColumnCell">${{ToDecimalPoints(totalcost,totaltons)}}</td>
                      <td class="ColumnCell">${{ToDecimalPoints(totalGETcost,totaltons)}}</td>


                  </ng-container>
                </tbody>
              </table>
            </div>
            <table class="table table--striped table--full-width">

              <thead>
                <tr>
                  <th>Model</th>
                  <th>Unit #</th>
                  <th>Serial #</th>
                  <th>Implement #</th>
                  <th>Date</th>
                  <th>Action</th>
                  <th>SMU</th>
                  <th>Asset CMU</th>
                  <th>Cycle No</th>
                  <th>Cycle CMU</th>
                  <th>BCM</th>
                  <th>Tons</th>
                  <th>Capital Cost</th>
                  <th>Maintenance </th>
                  <th>GET Cost</th>
                  <th>Total Cost</th>
                  <th>Total Running Cost</th>
                  <th>Comment</th>
                  <th>Repairer</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody style="font-size: smaller;">
                <ng-container *ngFor="let OP of historyDetails_">
                  <tr>
                    <td>{{OP.Model}}</td>
                    <td>{{OP.Unit}}</td>
                    <td>{{OP.Serial}}</td>
                    <td>{{OP.ImplementName}}</td>
                    <td style="white-space: nowrap;">{{OP.ActionDate | date : 'dd-MMM-yyyy'}}</td>
                    <td>{{OP.ActionName}}</td>
                    <td>{{OP.Hours | number: '1.'}}</td>
                    <td>{{OP.HoursDiff | number: '1.'}}</td>
                    <td>{{OP.CycleNo }}</td>
                    <td>{{OP.CycleCMU | number: '1.'}}</td>
                    <td>
                      <!--  {{OP.BCM ==-1?0:OP.BCM | number: '1.'}}-->
                      <span *ngIf="!(!editableBCM && OP.EQBCMTonId == currentClickedId)"
                        style="display: flex; align-items: center;">
                        <span>{{OP.BCM ==-1?0:OP.BCM | number: '1.'}}</span>
                        <span *ngIf="isAdministrator && OP.BCM > 0">
                          <i class="material-icons text-container__edit editcancel" style="font-size :21px;"
                            title="Click to edit" (click)="editBCM(OP.EQBCMTonId)">edit</i>
                        </span>
                      </span>
                      <span *ngIf="!editableBCM && OP.EQBCMTonId == currentClickedId && isAdministrator"
                        class="text-block__important" style="display: flex;">
                        <span>
                          <input class="input-container__input" #dataInput style="width: 90px;"
                            [id]="'dataInput_BCM_' + OP.EQBCMTonId" [value]="OP.BCM" [(ngModel)]="OP.BCM" focusOnShow />
                        </span>

                        <i class="material-icons save-button__icon editcancel" title="Save changes."
                          (click)="onSaveBCM(OP.EQBCMTonId,OP.BCM)">check</i>
                        <i class="material-icons cancel-button__icon editcancel" title="Cancel changes."
                          (click)="onCancelBCM()">close</i>
                      </span>
                    </td>
                    <td>
                      <!--{{OP.Tons==-1?0:OP.Tons | number: '1.'}}-->
                      <span *ngIf="!(!editableTons && OP.EQBCMTonId == currentClickedId)"
                        style="display: flex; align-items: center;">
                        <span>
                          {{OP.Tons==-1?0:OP.Tons | number: '1.'}}
                        </span>
                        <span *ngIf="isAdministrator && OP.Tons > 0">
                          <i class="material-icons text-container__edit editcancel" style="font-size :21px;"
                            title="Click to edit" (click)="editTons(OP.EQBCMTonId)">edit</i>
                        </span>
                      </span>
                      <span *ngIf="!editableTons && OP.EQBCMTonId == currentClickedId && isAdministrator"
                        class="text-block__important" style="display: flex;">
                        <span>
                          <input class="input-container__input" #dataInput style="width: 90px;"
                            [id]="'dataInput_Tons_' + OP.EQBCMTonId" [value]="OP.Tons" [(ngModel)]="OP.Tons"
                            focusOnShow />
                        </span>

                        <i class="material-icons save-button__icon editcancel" title="Save changes."
                          (click)="onSaveTons(OP.EQBCMTonId,OP.Tons)">check</i>
                        <i class="material-icons cancel-button__icon editcancel" title="Cancel changes."
                          (click)="onCancelTons()">close</i>
                      </span>
                    </td>
                    <td>
                      <!--  ${{OP.CapitalCost  | number: '.2'}}-->
                      <span *ngIf="!(!editableCapitalCost && OP.ActionId == currentClickedId)"
                        style="display: flex; align-items: center;">
                        <span>
                          ${{OP.CapitalCost | number: '.2'}}
                        </span>
                        <span
                          *ngIf="isAdministrator && (OP.ActionAuto == 3 || OP.ActionAuto == 8 || OP.ActionAuto == 11 || OP.ActionAuto == 13)">
                          <i class="material-icons text-container__edit editcancel" style="font-size :21px;"
                            title="Click to edit" (click)="editCapitalCost(OP.ActionId)">edit</i>
                        </span>
                      </span>
                      <span
                        *ngIf="!editableCapitalCost && OP.ActionId == currentClickedId && isAdministrator && (OP.ActionAuto == 3 || OP.ActionAuto == 8  || OP.ActionAuto == 11 || OP.ActionAuto == 13)"
                        class="text-block__important" style="display: flex;">
                        <span>
                          <input class="input-container__input" #dataInput style="width: 90px;"
                            [id]="'dataInput_CC_' + OP.ActionId" [value]="OP.CapitalCost" [(ngModel)]="OP.CapitalCost"
                            focusOnShow />
                        </span>

                        <i class="material-icons save-button__icon editcancel" title="Save changes."
                          (click)="onSaveCapitalCost(OP.ActionId,OP.CapitalCost)">check</i>
                        <i class="material-icons cancel-button__icon editcancel" title="Cancel changes."
                          (click)="onCancelCapitalCost()">close</i>


                      </span>


                    </td>
                    <td>
                      <!--${{OP.MaintenanceCost  | number: '.2'}}-->
                      <span *ngIf="!(!editableMaintenanceCost && OP.ActionId == currentClickedId)"
                        style="display: flex; align-items: center;">
                        <span>
                          ${{OP.MaintenanceCost | number: '.2'}}
                        </span>
                        <span
                          *ngIf="isAdministrator && (OP.ActionAuto == 4 || OP.ActionAuto == 11 || OP.ActionAuto == 14)">
                          <i class="material-icons text-container__edit editcancel" style="font-size :21px;"
                            title="Click to edit" (click)="editMaintenanceCost(OP.ActionId)">edit</i>
                        </span>
                      </span>
                      <span
                        *ngIf="!editableMaintenanceCost && OP.ActionId == currentClickedId && isAdministrator && (OP.ActionAuto == 4 || OP.ActionAuto == 11 || OP.ActionAuto == 14)"
                        class="text-block__important" style="display: flex;">
                        <span>
                          <input class="input-container__input" #dataInput style="width: 90px;"
                            [id]="'dataInput_MC_' + OP.ActionId" [value]="OP.MaintenanceCost"
                            [(ngModel)]="OP.MaintenanceCost" focusOnShow />
                        </span>

                        <i class="material-icons save-button__icon editcancel" title="Save changes."
                          (click)="onSaveMaintenanceCost(OP.ActionId,OP.MaintenanceCost)">check</i>
                        <i class="material-icons cancel-button__icon editcancel" title="Cancel changes."
                          (click)="onCancelMaintenanceCost()">close</i>
                      </span>
                    </td>
                    <td>${{OP.GETCost | number: '.2'}}</td>
                    <td>${{OP.Cost | number: '.2'}}</td>
                    <td>${{OP.TotalRunningCost | number: '.2'}}</td>
                    <td>{{OP.comment}}</td>
                    <td>{{OP.Repairer}}</td>
                    <td>{{OP.Location}}</td>
                </ng-container>
              </tbody>
            </table>



          </div>
        </div>
      </mat-tab>
      <mat-tab label="ASSET INSPECTION HISTORY" *ngIf="inspectionDetails!=null">
        <div *ngIf="ImplementForEquipmentDetails != null">

          <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto; " class="mat-elevation-z8">

              <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
                <!-- <app-implement-details-header [Implemetdetails]="implement.ImplementSummary" [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header> -->
                <app-implement-details-header [Implemetdetails]="ImplementSummaryForEquipmentDetails"
                  [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
              </div>
              <ng-container *ngIf="AssetDetailsHistroy?.SchematicAndObservationPoints!=null">
                <ng-container *ngFor="let item2 of AssetDetailsHistroy.SchematicAndObservationPoints">
                  <app-implement-details-history [SchematicAndObservationPoints]="item2" [ImplementId]="ImplementId"
                    [(cusID)]="CustomerId" [(SMU)]="SMU" (updateObs)="loadImplementDetailsHistroy()">
                  </app-implement-details-history>
                </ng-container>
              </ng-container>


            </div>
          </ng-container>

        </div>
      </mat-tab>

      <mat-tab label="CRACK REGISTER" *ngIf="hasCrack==true">
        <div *ngIf="ImplementForEquipmentDetails != null">

          <ng-container *ngFor="let implement of ImplementForEquipmentDetails">
            <div style="overflow-x: auto; " class="mat-elevation-z8">

              <div style="background-color: white; padding: 1%;     margin-right: -15%;    max-width: 100%;">
                <app-implement-details-header [Implemetdetails]="implement.ImplementSummary"
                  [evaldetails]="ImplementForEquipmentDetails"></app-implement-details-header>
              </div>
              <ng-container *ngFor="let item2 of implement.SchematicAndObservationPoints">
                <app-observation-details [SchematicAndObservationPoints]="item2" [(cusID)]="CustomerId" [(SMU)]="SMU"
                  [isCrack]="2" [ImplementId]="ImplementId" (updateObs)="loadImplementDetails()">
                </app-observation-details>
              </ng-container>

            </div>
          </ng-container>

        </div>
      </mat-tab>

    </div>
  </mat-tab-group>
</div>







<!--
<div #btnStatusChange class="alert cursor-pointer" (click)="openChangeStatusModal()" *ngIf="showImplement"
     (mouseenter)="mouseOverStatus()" (mouseleave)="mouseLeaveStatus()">
    <i class="material-icons alert__icon">build</i>
    <div class="alert__content">
        <span class="alert__content__title">{{implementStatusText}}</span>
        <span class="alert__content__message" [innerHTML]="implementStatusDesc"></span>
    </div>
</div>
<div class="panel">
    <div class="panel__header">
        <span class="panel__header__title">Overview</span>
        <div class="panel__header__button-container">

            <a class="button button--primary margin-right-8" (click)="openRemoveImplementModal()" *ngIf="showRemoveImplementModal"><i class="material-icons button__icon">layers</i><span class="button__text">Move to Inventory</span></a>
            <a class="button button--primary margin-right-8" (click)="openAttachImplementModal()" *ngIf="showAttachImplementModal"><i class="material-icons button__icon">add</i><span class="button__text">Attach to Equipment</span></a>
            <a class="button" [matMenuTriggerFor]="implementMoreMenu" *ngIf="showChangeJobsiteModal"><i class="material-icons button__icon">more_vert</i><span class="button__text">More</span></a>
            <mat-menu #implementMoreMenu="matMenu">
                <button (click)="openChangeImplementJobsiteModal()" mat-menu-item>
                    <mat-icon>edit_location</mat-icon>
                    <span>Change Job Site</span>
                </button>

            </mat-menu>
        </div>
    </div>
    <div class="panel__content" *ngIf="showImplement">
        <div class="flex flex--align-center">
            <div id="data-percentageRemaining" class="bold font-size--xl margin-right-24">
                {{implement.condition}}%
            </div>
            <div class="column-container flex-grow">
                <div class="column-container__column">
                    <div class="text-block">
                        <span class="text-block__label">
                            Customer
                        </span>
                        <span class="text-block__important">
                            {{implement.customer}}
                        </span>
                    </div>
                    <div class="text-block">
                        <span class="text-block__label">
                            Job Site
                        </span>
                        <span class="text-block__important">{{implement.jobsite}}</span>
                    </div>
                </div>
                <div class="column-container__column">
                    <div class="text-block">
                        <span class="text-block__label">
                            Make
                        </span>
                        <span class="text-block__important">
                            {{implement.make}}
                        </span>
                    </div>
                    <div class="text-block">
                        <span class="text-block__label">
                            Model
                        </span>
                        <span class="text-block__important">{{implement.model}}</span>
                    </div>
                </div>
                <div class="column-container__column">
                    <div class="text-block">
                        <span class="text-block__label">
                            Life (hrs)
                        </span>
                        <span class="text-block__important">
                            {{implement.life}}
                        </span>
                    </div>
                    <div class="text-block">
                        <span class="text-block__label">
                            Type
                        </span>
                        <span class="text-block__important">{{ implement.implementType }}</span>
                    </div>
                </div>
                <div class="column-container__column">
                    <div class="text-block">
                        <span class="text-block__label">
                            Serial Number
                        </span>
                        <span class="text-block__important">
                            {{implement.serialNo}}
                        </span>
                    </div>
                    <div class="text-block">
                        <span class="text-block__label">
                            Last Inspection
                        </span>
                        <span class="text-block__important">{{implement.lastInspection}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
